import { useState } from 'react';
import { useStore } from '../contexts/StoreContext';
import Api from '../utils/Api';

export function useFinishLessonSingleCustomer(): [boolean, () => Promise<void>] {
    const { recordingStore, tempoStore, lessonStore } = useStore();
    const [isProcessing, setIsProsessing] = useState(false);
    const callback = async (): Promise<void> => {
        setIsProsessing(true)
        try {
            const { viewedCustomer } = lessonStore;
            const { selectedCoach } = tempoStore;
            if (!selectedCoach) {
                throw Error('no coarch selected');
            }
            const { id, lesson_master_id } = viewedCustomer;
            const comment = lessonStore.getLessonComment(String(id));
            const curriculumValues =
                lessonStore.getLessonRecord(String(id)) ?? [];
            const videoData =
                recordingStore.getRegisteredVideo(String(id)) ?? [];
            await Api.createCustomerLesson(
                id,
                lesson_master_id,
                selectedCoach.id,
                comment,
                curriculumValues,
                videoData,
            );
        } finally {
            setIsProsessing(false);
        }
    }

    return [isProcessing, callback]
}
